import { HeadlineWithOptionalCta } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { C03HeadlineWithOptionalCTAProps } from './C03HeadlineWithOptionalCTA.types';
import { GetHeadlineWIthOptionalCTAModel } from './C03HeadlineWithOptionalCTA.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C03HeadlineWithOptionalCTAProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <HeadlineWithOptionalCta
      data-component={marketingRenderingName}
      {...GetHeadlineWIthOptionalCTAModel(props)}
    />
  );
};
